import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Eleicao } from 'src/app/models/eleicao.model';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { GestoresService } from 'src/app/services/gestores.service';

@Component({
  selector: 'app-relatorio-votos',
  templateUrl: './relatorio-votos.component.html',
  styleUrls: ['./relatorio-votos.component.css']
})
export class RelatorioVotosComponent implements OnInit {

  public token: any;
  public idEleicao: any;
  // public eleicao: Eleicao;
  constructor(
    protected router: Router,
    public route: ActivatedRoute,
    protected eleicaoServices: EleicaoService,
    protected gestoresServices: GestoresService
    ) { }

  ngOnInit() {
    this.token = sessionStorage.getItem("token");
    this.idEleicao = sessionStorage.getItem("idEleicao");
    this.getEleicao(this.idEleicao, this.token);
  }

  getEleicao(idEleicao: number, token: any) {
    this.eleicaoServices.getById(idEleicao, token).then((eleicao: Eleicao) => {
      this.idEleicao = eleicao;
    }).catch(err => {
      this.router.navigate(['/error-sessao']);
    });
  }
  
  volta(){
    window.history.back();
}
}
